import { AuthentificationType } from "@/types/AuthentificationType";
import { UtilisateurDto } from "@/types/UtilisateurType";
const API_URL = import.meta.env.VITE_API_URL;
export const authApi = {
  loginWithGoogle: async (): Promise<void> => {
    window.location.href = process.env.NEXT_PUBLIC_GOOGLE_AUTH_URL!;
  },

  getSession: async (): Promise<UtilisateurDto> => {
    const response = await fetch(`/api/jour-gui/auth/session`, {
      method: "GET",
      credentials: "include",
    });

    try {
      const userData = await response.json();
      return userData;
    } catch (error) {
      throw new Error(
        "les informations de l'utilisateur ne sont pas accécible."
      );
    }

    return response.json();
  },

  endSession: async (): Promise<void> => {
    await fetch(`/api/jour-gui/auth/session`, {
      method: "DELETE",
      credentials: "include",
    });
    localStorage.removeItem("authToken");
  },

  finaliserInscriptionGoogle: async (values: UtilisateurDto): Promise<void> => {
    values.villeActivite.replace(" ", "_");
    values.villeNaissance.replace(" ", "_");
    const response = await fetch(
      `/api/jour-gui/auth/finaliser-inscription-google`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(values),
      }
    );

    if (!response.ok) {
      const errorData = await response.json().catch(() => null);
      const errorMessage =
        errorData?.error || errorData?.message || response.statusText;
      throw new Error(`Erreur HTTP: ${response.status} - ${errorMessage}`);
    }
  },
};

export const fetchVilles = async (): Promise<string[]> => {
  try {
    const response = await fetch(`${API_URL}/public/villes`);
    if (!response.ok) throw new Error(`Erreur HTTP: ${response.status}`);

    const villes = await response.json();
    return villes.map((ville: string) => ville.replace(/_/g, " "));
  } catch {
    throw new Error("Impossible de charger les villes.");
  }
};

export const inscrireUtilisateur = async (userData: UtilisateurDto) => {
  const response = await fetch(`${API_URL}/api/jour-gui/public/inscription`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(userData),
  });

  const responseText = await response.text();

  if (!response.ok) {
    throw responseText;
  }

  return JSON.parse(responseText);
};

export const connexion = async (
  credentials: AuthentificationType
): Promise<string> => {
  try {
    const response = await fetch(`/api/jour-gui/public/authentification`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(credentials),
    });

    const responseText = await response.text();

    if (!response.ok) {
      throw responseText;
    }

    return responseText;
  } catch (error) {
    return "NOK";
  }
};

export const recuperationService = {
  sendCode: async (login: string): Promise<void> => {
    const email = encodeURIComponent(login);

    const response = await fetch(
      `/api/jour-gui/public/authentification/${email}`,
      {
        method: "GET",
      }
    );

    if (!response.ok) {
      const error = await response.json().catch(() => null);
      throw new Error(error?.message || "Erreur lors de l'envoi du code OTP");
    }
    localStorage.setItem("pendingEmail", login);
    localStorage.setItem("authContext", "reset");
  },

  verifyCode: async (
    login: string,
    code: string,
    isProfessional: boolean
  ): Promise<string> => {
    const email = encodeURIComponent(login);
    const response = await fetch(
      `/api/jour-gui/public/authentification/${email}/${code}/${isProfessional}`,
      { method: "GET" }
    );

    if (!response.ok) {
      const error = await response.json().catch(() => null);
      throw new Error(error?.message || "Code OTP invalide");
    }

    const data = await response.text();
    const cleanToken = data
      .replace("/changer/mot-de-passe/", "")
      .replace("/configuration/espace/", "");
    return cleanToken;
  },

  changePassword: async (
    changePassword: AuthentificationType
  ): Promise<void> => {
    const response = await fetch("/api/jour-gui/public/authentification", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(changePassword),
    });

    if (!response.ok) {
      throw new Error("Erreur lors du changement de mot de passe");
    }

    return;
  },
};
